/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePortfolioCommand } from '../../models/create-portfolio-command';
import { CreatePortfolioCommandResult } from '../../models/create-portfolio-command-result';

export interface ApiPortfolioCreatePortfolioPost$Plain$Params {
      body?: CreatePortfolioCommand
}

export function apiPortfolioCreatePortfolioPost$Plain(http: HttpClient, rootUrl: string, params?: ApiPortfolioCreatePortfolioPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePortfolioCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPortfolioCreatePortfolioPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatePortfolioCommandResult>;
    })
  );
}

apiPortfolioCreatePortfolioPost$Plain.PATH = '/api/Portfolio/CreatePortfolio';
